/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {adminHardDeleteSyncEntities} from '../api'

export const useMutationAdminHardDeleteSyncEntities = createReactQueryMutationHook('adminHardDeleteSyncEntities', adminHardDeleteSyncEntities)
